"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var config_1 = require("../config");
var next_1 = require("@alifd/next");
var util_1 = require("@aligov/util");
var task_1 = require("@alife/task");
var Cookie = require("js-cookie");
var contextManage_1 = require("../contextManage");
var config_2 = require("../config");
var esign_image_1 = require("../static/images/esign-image");
var scan_image_1 = require("../static/images/scan-image");
var FaceScan = function (props) {
    var context = react_1.useContext(contextManage_1.DeviceTaskContext);
    react_1.useEffect(function () {
        if (context.progress === config_1.PROCESS.pending) {
            createFaceTask(context.cardNumber, context.cardName);
        }
        if (context.progress === config_1.PROCESS.success) {
            faceTaskHandle();
        }
    }, [context.progress]);
    var resendTask = function (isAuto) {
        if (isAuto === 0) {
            createFaceTask(context.cardNumber, context.cardName);
        }
        else if (isAuto === 1) {
            // 手动认证 去二次验证
            context.clear();
            context.setStatus(config_1.TASKTYPE.doubleConfirm);
        }
    };
    var createFaceTask = function (idCardNumber, idCardName) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, context.createTask(config_1.TASKTYPE.faceScanAuth, JSON.stringify({ idCardNumber: idCardNumber, idCardName: idCardName }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); };
    var faceTaskHandle = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, faceRegister(JSON.parse(context.taskResult.list[0].result).bizNo)];
                case 1:
                    _a.sent();
                    context.clear();
                    return [2 /*return*/];
            }
        });
    }); };
    var faceRegister = function (bizno) { return __awaiter(_this, void 0, void 0, function () {
        var cardNumber, cardName, result, govAuthCode, host, address, iframeUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cardNumber = context.cardNumber, cardName = context.cardName;
                    return [4 /*yield*/, util_1.request.post("/app_api/userFacePass/faceRegister", {
                            data: {
                                bizno: bizno,
                                registerType: "simple",
                                username: cardName,
                                idtype: "1",
                                idnum: cardNumber,
                                source: "pad_pc",
                            },
                        })];
                case 1:
                    result = _a.sent();
                    if (result && result.psid) {
                        task_1.GovCookie.personSet(result);
                        govAuthCode = Cookie.get("govAuthCode");
                        host = task_1.Util.getHost();
                        address = "\n      " + host.receptHost + "/form/auth?psid=" + result.psid + "&accountSource=HYDJ&userType=gov&channel=pc&goto=";
                        iframeUrl = encodeURIComponent(address +
                            encodeURIComponent(host.receptHost + "/online/offline-intg/accept#/accept/entry?matterType=" + props.matterType + "&matterId=" + props.matterId + "&bizChannel=offline-intg&gpy_type=" + props.channelCode.name + "&govAuthCode=" + govAuthCode + "&backUrl=" + location.href));
                        location.href = "" + location.origin + config_2.PORTAL_PREFEX + "/#/smarthall-recept/recept?iframeUrl=" + iframeUrl;
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    if (context.progress === config_1.PROCESS.pending) {
        return (React.createElement("div", null,
            React.createElement("div", { className: "status", key: 1 }, "\u4EFB\u52A1\u53D1\u9001\u4E2D\uFF0C\u8BF7\u7A0D\u540E"),
            React.createElement("div", { className: "payload", key: 2 },
                React.createElement("img", { src: esign_image_1.default })),
            React.createElement("div", { className: "center" },
                React.createElement(next_1.Button, { type: "primary", onClick: function () { context.closeDialog(); } }, "\u5173\u95ED"))));
    }
    else if (context.progress === config_1.PROCESS.processing) {
        return (React.createElement("div", null,
            React.createElement("div", { className: "status", key: 1 }, "\u8BF7\u63D0\u9192\u529E\u4E8B\u4EBA\u9762\u5BF9Pad\uFF0C\u8FDB\u884C\u4EBA\u8138\u8BC6\u522B"),
            React.createElement("div", { className: "payload", key: 2 },
                React.createElement("img", { src: esign_image_1.default })),
            React.createElement("div", { className: "center" },
                React.createElement(next_1.Button, { type: "primary", onClick: function () { context.closeDialog(); } }, "\u5173\u95ED\u00B7"))));
    }
    else if (context.progress === config_1.PROCESS.success) {
        return (React.createElement("div", null,
            React.createElement("div", { className: "status1", key: 1 }, "\u8EAB\u4EFD\u4FE1\u606F\u8BC6\u522B\u6210\u529F\uFF01"),
            React.createElement("div", { className: "payload", key: 2 },
                React.createElement("img", { src: scan_image_1.default }))));
    }
    else if (context.progress === config_1.PROCESS.failed) {
        return (React.createElement("div", null,
            React.createElement("div", { className: "red_txt" }, "\u4EBA\u8138\u9A8C\u8BC1\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5\uFF01"),
            React.createElement("div", { className: "statusFailed", key: 1 },
                React.createElement("span", { onClick: function () { resendTask(0); }, className: "mr20" }, "\u91CD\u65B0\u53D1\u9001"),
                React.createElement("span", { onClick: function () { resendTask(1); } }, "\u4EBA\u5DE5\u6838\u9A8C")),
            React.createElement("div", { className: "payload", key: 2 },
                React.createElement("img", { src: esign_image_1.default })),
            React.createElement("div", { className: "center" },
                React.createElement(next_1.Button, { type: "primary", onClick: context.closeDialog }, "\u5173\u95ED"))));
    }
    return React.createElement("div", null);
};
exports.default = FaceScan;
